import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import { Fields, typeToDisplay } from './Entries';
import Typography from '@material-ui/core/Typography';
import AppsIcon from '@material-ui/icons/Apps';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    root: {
        [theme.breakpoints.up('lg')]: {
            paddingLeft: '15%',
            paddingRight: '15%',
        },
    },
    fieldsHeader: {
        padding: theme.spacing(2),
        paddingTop: theme.spacing(4),
    },
    rightSideBarList: {
        overflow: 'hidden',
    },
});

class FieldsPanel extends React.Component {
    handleAddField = (typeId) => {
        this.props.handleAddField(typeId);
    };

    render() {
        const isOpen = this.props.isOpen;
        return (
            <React.Fragment>
                {isOpen ? (
                    <Typography
                        variant="h6"
                        color="primary"
                        className={this.props.classes.fieldsHeader}
                        style={{ marginLeft: 15 }}
                    >
                        {' '}
                        Add a Field
                    </Typography>
                ) : (
                    <AppsIcon color="primary" aria-label="Add a Field" className={this.props.classes.fieldsHeader} />
                )}

                <List component="div" className={this.props.classes.rightSideBarList}>
                    {Fields.map((control, index) => {
                        return control.typeId !== 'multiple' || !this.props.inMultipleMode ? (
                            <React.Fragment key={control.typeId}>
                                {isOpen ? (
                                    <ListItem button onClick={() => this.handleAddField(control.typeId)}>
                                        <ListItemIcon>{<control.icon />}</ListItemIcon>
                                        <ListItemText primary={typeToDisplay(control.typeId)} />
                                    </ListItem>
                                ) : (
                                    <ListItem button onClick={() => this.handleAddField(control.typeId)}>
                                        <ListItemIcon>{<control.icon />}</ListItemIcon>
                                    </ListItem>
                                )}

                                {index < Fields.length && isOpen && <Divider />}
                            </React.Fragment>
                        ) : null;
                    })}
                </List>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(FieldsPanel);
